module.exports = __webpack_public_path__ + "static/math-26ce9ba92fc2d4e62ea8881eeae6e8ce.jpg";